
module Meevo.Plugins.ClientApp {
    import SettingsDto = Meevo.Model.SettingsDto;
    import ISelectItem = Meevo.Model.ISelectItem;
    "use strict";


    import LocationStatusEnum = Meevo.Model.LocationStatusEnum;
    import ClientMembershipBillStatusEnum = Meevo.Model.ClientMembershipBillStatusEnum;
    interface IStatus {
        label: string;
        value: LocationStatusEnum | ClientMembershipBillStatusEnum;
    }
    enum LiveChatEnum {
        Live,
        Other
    }

    /**
    * Preferences Section of BusinessInfo
    */

    export class SettingsSection extends Meevo.Components.CommonClasses.SettingsSectionBase {
        public onlineBookingPlaceholderUrl = "https://meevo.com";
        public isOnlineBookingEnabled = false;
        public customButtonsSet: any;
        public copy: any;
        public auditNoun: Meevo.Model.NounEnum;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected basedataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string,
            protected context?: Meevo.Plugins.ClientApp.ClientAppContext
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, modalService, sectionSecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
            this.initializeData();
        }

        initializeData(): void {
            this.auditNoun = Meevo.Model.NounEnum.ClientAppSettings;
            this.getSettings();

            this.securityService.checkModuleAccess(Meevo.Components.Common.SecurityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS
                + Meevo.Components.Common.SecurityParts.KEY_PART_READ).
                then((securityAccess: Meevo.Model.SecurityAccessEnum) => {
                    if (securityAccess == Meevo.Model.SecurityAccessEnum.Grant) {
                        this.isOnlineBookingEnabled = true;
                        this.dataService.customMethodData("api/settings/OnlineBooking?includeMetadata=true", "GET", null).then((res) => {
                            if (res != null && res.data != null)
                                this.onlineBookingPlaceholderUrl = res.data.clusterOnlineBookingUrl;
                        });
                    }
                });

            this.context.setMode(Model.MaintenanceFormState.Readonly);
            this.mode = Model.MaintenanceFormState.Readonly;

            var scope = this;
            this.customButtonsSet = [
                {
                    text: 'LABEL_EDIT',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppSettingsTab, Model.VerbEnum.EditButtonClicked, null, null);
                        scope.context.edit();
                        this.copy = angular.copy(this.model);
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => (this.context.isApplicationModeCO() || this.identityService.isSingleLocation()) && this.mode == Model.MaintenanceFormState.Readonly,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_SETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_SAVE',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppSettingsTab, Model.VerbEnum.SaveButtonClicked, null, null);
                        scope.saveSettings();
                        this.mode = Model.MaintenanceFormState.Readonly;
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => (this.context.isApplicationModeCO() || this.identityService.isSingleLocation()) && this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_SETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_CANCEL',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppSettingsTab, Model.VerbEnum.CancelButtonClicked, null, null);
                        this.model = angular.copy(this.copy);
                        scope.context.setMode(Model.MaintenanceFormState.Readonly);
                        scope.mode = Model.MaintenanceFormState.Readonly;
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => (this.context.isApplicationModeCO() || this.identityService.isSingleLocation()) && this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_SETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
            ];
        }

        isSingleLocation = (): boolean => {
            if (Model.Guard.isSomething(this.identityService.current().isSingleLocation))
                return this.identityService.current().isSingleLocation;
            else
                return false;
        }


        //public updateModel(): void {
        //    let uri = `/${Meevo.AppSettings.Default.API_ROOT}${this.baseEndpoint}/${this.sectionEndpoint}`;
        //    if (this.businessTypeDetail) {
        //        this.model.businessTypeId = this.businessTypeDetail.id;

        //        let parameters = {
        //            businessTypeId: this.model.businessTypeId
        //        }
        //        this.dataService.customMethodData(uri, 'GET', '', parameters).then((results: any) => {
        //            let temp = this.businessTypeDetail;
        //            this.model = results.data;
        //            this.businessTypeDetail = temp;
        //        });
        //    }

        //}

        getSettings() {
            this.dataService.customMethodData("api/ClientApp/Settings?includeMetadata=true", "GET", this.model).then((data) => {
                if (data.data) {
                    this.model = data.data;
                }
            });
        }

        saveSettings(): void {
            this.dataService.customMethodData("api/ClientApp/ClientAppSettings", "POST", this.model).then((data) => {
                if (data.data) {
                    //TODO: GET Latest Data OR Refresh current Data With Return data Based on new SP Output
                    this.copy = angular.copy(this.model);
                }
            });
        }

    }
}
